import { render, staticRenderFns } from "./Rasxod.vue?vue&type=template&id=5ecc00ca&scoped=true"
import script from "./Rasxod.vue?vue&type=script&lang=js"
export * from "./Rasxod.vue?vue&type=script&lang=js"
import style0 from "./Rasxod.vue?vue&type=style&index=0&id=5ecc00ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecc00ca",
  null
  
)

export default component.exports